import {useContext, useMemo} from 'react';
import cx from 'classnames';
import {Container} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Container';
import {BackgroundEditor} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/BackgroundEditor';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {OverlayAnimation} from '~/common/OverlayAnimation/OverlayAnimation';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {Background} from '~/common/fabric/CreateDesign/components/Background/Background';

import './BackgroundContainer.sass';

export const BackgroundContainer = ({children}) => {
  const isLargishAndUp = useIsLargishAndUp();
  const {effectVideo} = useContext(EventCreateContext);
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  const effectAnimation = useMemo(
    () => <OverlayAnimation autoPlay effectVideo={effectVideo} />,
    [effectVideo]
  );

  return (
    <>
      <Container
        className={cx('event-create-editor event-create-editor--background', {
          'onestep-edit-ABTest__editor-wrapper': isInEditButtonTest,
        })}
      >
        {children}
        <Background />
        {isLargishAndUp && <BackgroundEditor />}
      </Container>
      {effectAnimation}
    </>
  );
};
